module.exports = __webpack_public_path__ + "media/images/common/new_entry_btn_ov-553db68dcd3ce7ea9492154c111c7555.gif";